
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class PenroseTilingEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config } = pc;
         const size = (150 + layerIndex * 50) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, size);
        const scale = config.parallaxScale || 1.0;

        ctx.strokeStyle = pc.color;
        ctx.lineWidth = 1 * scale;

        const drawRhombus = (x: number, y: number, s: number, angle: number) => {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(angle);
            ctx.beginPath();
            ctx.moveTo(0, 0);
            ctx.lineTo(s, 0);
            ctx.lineTo(s + s * Math.cos(Math.PI * 0.4), s * Math.sin(Math.PI * 0.4));
            ctx.lineTo(s * Math.cos(Math.PI * 0.4), s * Math.sin(Math.PI * 0.4));
            ctx.closePath();
            ctx.stroke();
            ctx.restore();
        };

        const draw = () => {
            for (let x = x1; x <= x2; x += size) {
                for (let y = y1; y <= y2; y += size) {
                    const rot = (this.pseudoRandom(x + y) * 5) * (Math.PI * 2 / 5);
                    drawRhombus(x, y, size * 0.8 * scale, rot);
                }
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
